<div class="container">
  <section class="section has-text-centered">
    <h1 class="title">404</h1>
    <h2 class="subtitle">I'm sorry, but your princess is in another castle.</h2>

    <p> stand by while we redirect you to main page.</p>
  </section>
</div>
